import { render, staticRenderFns } from "./AppNew.vue?vue&type=template&id=5931f6a9&scoped=true&"
import script from "./AppNew.vue?vue&type=script&lang=js&"
export * from "./AppNew.vue?vue&type=script&lang=js&"
import style0 from "./AppNew.vue?vue&type=style&index=0&id=5931f6a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5931f6a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
